"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _helpers = require("./helpers");
var _constants = require("./constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SoundBoard = /*#__PURE__*/function () {
  function SoundBoard(soundstyle) {
    _classCallCheck(this, SoundBoard);
    _defineProperty(this, "soundstyle", _constants.SOUNDSTYLES.classic);
    _defineProperty(this, "context", void 0);
    _defineProperty(this, "destination", void 0);
    _defineProperty(this, "clickAudioBuffer", void 0);
    _defineProperty(this, "bellAudioBuffers", []);
    _defineProperty(this, "tradeStopBuffers", []);
    _defineProperty(this, "tradeStopSourcesGains", {});
    _defineProperty(this, "positionOpenPlaying", false);
    _defineProperty(this, "positionOpenBuffers", []);
    _defineProperty(this, "positionOpenSourcesGains", {});
    _defineProperty(this, "profitLoss", 0);
    if (soundstyle) {
      this.setSoundstyle(soundstyle);
    }
    this.init();
  }
  return _createClass(SoundBoard, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.context = new (window.AudioContext || window.webkitAudioContext)();
              this.destination = this.context.destination;
              _context.n = 1;
              return this.initBaseSounds();
            case 1:
              _context.n = 2;
              return this.initAdditionalSounds();
            case 2:
              this.restartPositionOpenIfPlaying();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initBaseSounds",
    value: function () {
      var _initBaseSounds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, Promise.all([this.initClick(), this.initSingleBell(), this.initSinglePositionOpen()]));
          }
        }, _callee2, this);
      }));
      function initBaseSounds() {
        return _initBaseSounds.apply(this, arguments);
      }
      return initBaseSounds;
    }()
  }, {
    key: "initAdditionalSounds",
    value: function () {
      var _initAdditionalSounds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.initRestBells();
            case 1:
              _context3.n = 2;
              return this.initRestPositionOpen();
            case 2:
              _context3.n = 3;
              return this.initTradeStop();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initAdditionalSounds() {
        return _initAdditionalSounds.apply(this, arguments);
      }
      return initAdditionalSounds;
    }()
  }, {
    key: "initClick",
    value: function () {
      var _initClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.getAudioBuffer(_constants.soundFiles.click);
            case 1:
              this.clickAudioBuffer = _context4.v;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initClick() {
        return _initClick.apply(this, arguments);
      }
      return initClick;
    }()
  }, {
    key: "initSingleBell",
    value: function () {
      var _initSingleBell = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.getAudioBuffer(_constants.soundFiles.bell.a);
            case 1:
              _t = _context5.v;
              this.bellAudioBuffers = [_t];
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function initSingleBell() {
        return _initSingleBell.apply(this, arguments);
      }
      return initSingleBell;
    }()
  }, {
    key: "initRestBells",
    value: function () {
      var _initRestBells = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _t2, _t3, _t4, _t5, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _t2 = [];
              _t3 = _toConsumableArray(this.bellAudioBuffers);
              _context6.n = 1;
              return this.getAudioBuffer(_constants.soundFiles.bell.b);
            case 1:
              _t4 = _context6.v;
              _context6.n = 2;
              return this.getAudioBuffer(_constants.soundFiles.bell.c);
            case 2:
              _t5 = _context6.v;
              _context6.n = 3;
              return this.getAudioBuffer(_constants.soundFiles.bell.d);
            case 3:
              _t6 = _context6.v;
              this.bellAudioBuffers = _t2.concat.call(_t2, _t3, [_t4, _t5, _t6]);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function initRestBells() {
        return _initRestBells.apply(this, arguments);
      }
      return initRestBells;
    }()
  }, {
    key: "initSinglePositionOpen",
    value: function () {
      var _initSinglePositionOpen = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var currentSoundstylePositionOpenSounds, _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              currentSoundstylePositionOpenSounds = _constants.soundFiles.positionOpen[this.soundstyle];
              _context7.n = 1;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.lneg1);
            case 1:
              _t7 = _context7.v;
              this.positionOpenBuffers = {
                lneg1: _t7
              };
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function initSinglePositionOpen() {
        return _initSinglePositionOpen.apply(this, arguments);
      }
      return initSinglePositionOpen;
    }()
  }, {
    key: "initRestPositionOpen",
    value: function () {
      var _initRestPositionOpen = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var currentSoundstylePositionOpenSounds, _t8, _t9, _t0, _t1, _t10, _t11, _t12, _t13, _t14, _t15;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              currentSoundstylePositionOpenSounds = _constants.soundFiles.positionOpen[this.soundstyle];
              _t8 = _objectSpread;
              _t9 = _objectSpread({}, this.positionOpenBuffers);
              _t0 = {};
              _context8.n = 1;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l0);
            case 1:
              _t1 = _context8.v;
              _context8.n = 2;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l1);
            case 2:
              _t10 = _context8.v;
              _context8.n = 3;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l2);
            case 3:
              _t11 = _context8.v;
              _context8.n = 4;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l3);
            case 4:
              _t12 = _context8.v;
              _context8.n = 5;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l4);
            case 5:
              _t13 = _context8.v;
              _context8.n = 6;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l5);
            case 6:
              _t14 = _context8.v;
              _context8.n = 7;
              return this.getAudioBuffer(currentSoundstylePositionOpenSounds.l6);
            case 7:
              _t15 = _context8.v;
              this.positionOpenBuffers = _t8(_t9, _t0, {
                l0: _t1,
                l1: _t10,
                l2: _t11,
                l3: _t12,
                l4: _t13,
                l5: _t14,
                l6: _t15
              });
            case 8:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function initRestPositionOpen() {
        return _initRestPositionOpen.apply(this, arguments);
      }
      return initRestPositionOpen;
    }()
  }, {
    key: "initTradeStop",
    value: function () {
      var _initTradeStop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _t16, _t17, _t18, _t19;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.getAudioBuffer(_constants.soundFiles.tradeStop.loss);
            case 1:
              _t16 = _context9.v;
              _context9.n = 2;
              return this.getAudioBuffer(_constants.soundFiles.tradeStop.win1);
            case 2:
              _t17 = _context9.v;
              _context9.n = 3;
              return this.getAudioBuffer(_constants.soundFiles.tradeStop.win2);
            case 3:
              _t18 = _context9.v;
              _context9.n = 4;
              return this.getAudioBuffer(_constants.soundFiles.tradeStop.win3);
            case 4:
              _t19 = _context9.v;
              this.tradeStopBuffers = {
                loss: _t16,
                win1: _t17,
                win2: _t18,
                win3: _t19
              };
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function initTradeStop() {
        return _initTradeStop.apply(this, arguments);
      }
      return initTradeStop;
    }()
  }, {
    key: "playClick",
    value: function playClick() {
      var clickSource = this.context.createBufferSource();
      if (this.clickAudioBuffer) {
        clickSource.buffer = this.clickAudioBuffer;
        clickSource.connect(this.destination);
        clickSource.start(0);
      }
    }
  }, {
    key: "setSoundstyle",
    value: function setSoundstyle(soundstyle) {
      if (Object.values(_constants.SOUNDSTYLES).includes(soundstyle)) {
        this.soundstyle = soundstyle;
      } else {
        throw new Error("Soundstyle \"".concat(soundstyle, "\" not supported."));
      }
    }
  }, {
    key: "playBell",
    value: function playBell() {
      var bellSource = this.context.createBufferSource();
      var randomBellBuffer = this.bellAudioBuffers[Math.floor(Math.random() * this.bellAudioBuffers.length)];
      if (randomBellBuffer) {
        bellSource.buffer = randomBellBuffer;
        bellSource.connect(this.destination);
        bellSource.start(0);
      }
    }
  }, {
    key: "restartPositionOpenIfPlaying",
    value: function restartPositionOpenIfPlaying() {
      if (this.positionOpenPlaying) {
        this.stopPositionOpen();
        this.playPositionOpen();
      }
    }
  }, {
    key: "playPositionOpen",
    value: function playPositionOpen() {
      var _this = this;
      if (!this.positionOpenPlaying) {
        Object.keys(_constants.positionOpenFadePoints).forEach(function (soundName) {
          _this.createSourceAndGainForPositionOpenBuffer(soundName);
        });
        Object.values(this.positionOpenSourcesGains).forEach(function (soundName) {
          soundName.source.start(0);
        });
        this.positionOpenPlaying = true;
      }
    }
  }, {
    key: "stopPositionOpen",
    value: function stopPositionOpen() {
      if (this.positionOpenPlaying) {
        Object.values(this.positionOpenSourcesGains).forEach(function (source) {
          if (source.source.playbackState === source.source.PLAYING_STATE) {
            source.source.stop(0);
          }
        });
        this.positionOpenSourcesGains = {};
        this.positionOpenPlaying = false;
      }
    }
  }, {
    key: "playTradeStop",
    value: function playTradeStop() {
      this.tradeStopSourcesGains = {
        loss: this.createSourceAndGainForTradeStopBuffer('loss'),
        win1: this.createSourceAndGainForTradeStopBuffer('win1'),
        win2: this.createSourceAndGainForTradeStopBuffer('win2'),
        win3: this.createSourceAndGainForTradeStopBuffer('win3')
      };
      Object.values(this.tradeStopSourcesGains).forEach(function (source) {
        source.source.start(0);
      });
    }
  }, {
    key: "createSourceAndGainForTradeStopBuffer",
    value: function createSourceAndGainForTradeStopBuffer(soundName) {
      if (this.tradeStopBuffers) {
        var buffer = this.tradeStopBuffers[soundName];
        var soundFadePoints = _constants.tradeStopFadePoints[soundName];
        var source = this.context.createBufferSource();
        source.buffer = buffer;
        var gainNode = this.context.createGain();
        gainNode.gain.value = (0, _helpers.getTradeStopGain)(soundFadePoints.fadeInPoint, soundFadePoints.fadeOutPoint, this.profitLoss);
        source.connect(gainNode);
        gainNode.connect(this.destination);
        return {
          source: source,
          gainNode: gainNode
        };
      }
    }
  }, {
    key: "createSourceAndGainForPositionOpenBuffer",
    value: function createSourceAndGainForPositionOpenBuffer(soundName) {
      var _this2 = this;
      var buffer;
      if (this.positionOpenBuffers && this.positionOpenBuffers[soundName]) {
        buffer = this.positionOpenBuffers[soundName];
        var soundFadePoints = _constants.positionOpenFadePoints[soundName];
        var source = this.context.createBufferSource();
        source.buffer = buffer;
        source.loop = true;
        var gainNode = this.context.createGain();
        gainNode.gain.value = (0, _helpers.getPositionOpenGain)(soundFadePoints.fadeInPoint, soundFadePoints.fadeOutPoint, this.profitLoss);
        source.connect(gainNode);
        gainNode.connect(this.destination);
        this.positionOpenSourcesGains[soundName] = {
          source: source,
          gainNode: gainNode
        };
      } else {
        setTimeout(function () {
          return _this2.updateSourceForPositionOpenBuffer(soundName);
        }, 500);
      }
    }
  }, {
    key: "updateSourceForPositionOpenBuffer",
    value: function updateSourceForPositionOpenBuffer(soundName) {
      var _this3 = this;
      if (this.positionOpenSourcesGains[soundName] && this.positionOpenSourcesGains[soundName].source.buffer === null) {
        if (this.positionOpenBuffers && this.positionOpenBuffers[soundName]) {
          this.positionOpenSourcesGains[soundName].source.buffer = this.positionOpenBuffers[soundName];
        } else {
          setTimeout(function () {
            return _this3.updateSourceForPositionOpenBuffer(soundName);
          }, 500);
        }
      }
    }
  }, {
    key: "setProfitLoss",
    value: function setProfitLoss(profitLoss) {
      if (profitLoss > 100) profitLoss = 100;
      if (this.profitLoss !== profitLoss) {
        this.profitLoss = profitLoss;
        if (Object.keys(this.positionOpenBuffers).length === 8 && this.positionOpenSourcesGains) {
          this.updatePositionOpenGains();
        }
      }
    }
  }, {
    key: "updatePositionOpenGains",
    value: function updatePositionOpenGains() {
      var _this4 = this;
      Object.keys(_constants.positionOpenFadePoints).forEach(function (soundName) {
        if (_this4.positionOpenSourcesGains[soundName]) {
          var currentSourceFadePoints = _constants.positionOpenFadePoints[soundName];
          _this4.positionOpenSourcesGains[soundName].gainNode.gain.value = (0, _helpers.getPositionOpenGain)(currentSourceFadePoints.fadeInPoint, currentSourceFadePoints.fadeOutPoint, _this4.profitLoss);
        }
      });
    }
  }, {
    key: "replaceSourcesForAllPositionOpenBuffers",
    value: function replaceSourcesForAllPositionOpenBuffers() {
      var _this5 = this;
      if (Object.keys(this.positionOpenSourcesGains).length !== 0) {
        Object.keys(_constants.positionOpenFadePoints).forEach(function (soundName) {
          _this5.replaceSourceForPositionOpenBuffer(soundName);
        });
      }
    }
  }, {
    key: "replaceSourceForPositionOpenBuffer",
    value: function replaceSourceForPositionOpenBuffer(soundName) {
      var _this6 = this;
      if (this.positionOpenSourcesGains[soundName] && this.positionOpenBuffers[soundName]) {
        var source = this.context.createBufferSource();
        source.buffer = this.positionOpenBuffers[soundName];
        source.loop = true;
        source.connect(this.positionOpenSourcesGains[soundName].gainNode);
        if (this.positionOpenSourcesGains[soundName].source.playbackState === this.positionOpenSourcesGains[soundName].source.PLAYING_STATE) {
          this.positionOpenSourcesGains[soundName].source.stop(0);
        }
        this.positionOpenSourcesGains[soundName].source = source;
        this.positionOpenSourcesGains[soundName].source.start(0);
      } else {
        setTimeout(function () {
          return _this6.replaceSourceForPositionOpenBuffer(soundName);
        }, 500);
      }
    }
  }, {
    key: "nullifyPositionOpenBuffers",
    value: function nullifyPositionOpenBuffers() {
      this.positionOpenBuffers = {
        lneg1: null,
        l0: null,
        l1: null,
        l2: null,
        l3: null,
        l4: null,
        l5: null,
        l6: null
      };
    }
  }, {
    key: "changeSoundstyle",
    value: function () {
      var _changeSoundstyle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(soundstyle) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this.setSoundstyle(soundstyle);
              this.nullifyPositionOpenBuffers();
              _context0.n = 1;
              return this.initSinglePositionOpen();
            case 1:
              _context0.n = 2;
              return this.initRestPositionOpen();
            case 2:
              this.replaceSourcesForAllPositionOpenBuffers();
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function changeSoundstyle(_x) {
        return _changeSoundstyle.apply(this, arguments);
      }
      return changeSoundstyle;
    }()
  }, {
    key: "getAudioBuffer",
    value: function () {
      var _getAudioBuffer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(url) {
        var soundFileBuffer, _t20;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return (0, _helpers.getSoundFileBuffer)(url);
            case 1:
              soundFileBuffer = _context1.v;
              _context1.n = 2;
              return this.context.decodeAudioData(soundFileBuffer);
            case 2:
              return _context1.a(2, _context1.v);
            case 3:
              _context1.p = 3;
              _t20 = _context1.v;
              if (!(_t20 instanceof DOMException && _t20.name === 'NotReadableError')) {
                _context1.n = 4;
                break;
              }
              return _context1.a(2, null);
            case 4:
              throw _t20;
            case 5:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 3]]);
      }));
      function getAudioBuffer(_x2) {
        return _getAudioBuffer.apply(this, arguments);
      }
      return getAudioBuffer;
    }()
  }]);
}();
var _default = exports["default"] = SoundBoard;